import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
var Create = {
  pn: 'div[data-name=create]',
  editingID: 0,
  draftKey: null,
  init: function init() {
    var self = this;
    self.draftKey = Base.draftKey;
    if (self.draftKey != null) self.loadDraft();
    $(self.pn + ' #dataline').submit(function (e) {
      self.newline();
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  },
  loadDraft: function loadDraft() {
    var self = this;
    $(self.pn + ' table.data-input-table tbody').html();

    try {
      var data = JSON.parse(localStorage.getItem(self.draftKey));
      data.forEach(function (item, i) {
        item.rowCount = i;
        $(self.pn + ' table.data-input-table tbody').append(self.lineFormat(item));
      });
      self.saveDraft();
      $(self.pn + ' table.data-input-table tbody tr a.remove').click(function (e) {
        $(this).closest('tr').remove();
        $(self.pn + ' table.data-input-table tbody').find('tr').each(function (item, i) {
          $(this).find('td:first-child').text(i + 1);
        });
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
      $(self.pn + ' table.data-input-table tbody tr').click(function (e) {
        self.editingID = $(this).attr("row-id");
        var code = $(this).find('.code').text();
        var qty = $(this).find('.qty').text();
        var note = $(this).find('.note').text();
        $(self.pn + ' input[name=dataline]').val("".concat(code, ";").concat(qty, ";").concat(note));
      });
    } catch (e) {
      console.log(e);
      Utils.notiError('Không đọc được dữ liệu nháp');
    }
  },
  lineFormat: function lineFormat(item) {
    return $("<tr row-id=\"".concat(item.rowCount + 1, "\">\n                  <td align=\"center\">").concat(item.rowCount + 1, "</td>\n                  <td class=\"code\">").concat(item.code, "</td>\n                  <td><div class=\"qty\">").concat(item.qty, "</div><div class=\"note\" style=\"font-size:10px; color:gray\">").concat(item.note, "</div></td>\n                  <td><a href=\"#\" class=\"color-red remove\"><i class=\"f7-icons icon\" style=\"font-size:15px;\">multiply_circle_fill</i></a></td>\n                </tr>"));
  },
  newline: function () {
    var _newline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var self, dataRow, rs, code, qty, note, rowCount, tr, _tr;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              dataRow = $(self.pn + ' input[name=dataline]').val().trim();
              rs = Base.checkValidNewline(dataRow);

              if (rs) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", false);

            case 5:
              code = rs.code;
              qty = rs.qty;
              note = rs.note;

              if (!(self.editingID == 0)) {
                _context.next = 19;
                break;
              }

              _context.next = 11;
              return Base.canhbaoNhatHang(code);

            case 11:
              rowCount = $(self.pn + ' table.data-input-table tbody').find('tr').length;
              tr = self.lineFormat({
                rowCount: rowCount,
                code: code,
                qty: qty,
                note: note
              });
              $(self.pn + ' table.data-input-table tbody').append(tr);
              $(self.pn + ' input[name=dataline]').val('');
              $(self.pn + ' table.data-input-table tbody tr:last-child a.remove').click(function (e) {
                $(this).closest('tr').remove();
                $(self.pn + ' table.data-input-table tbody').find('tr').each(function (item, i) {
                  $(this).find('td:first-child').text(i + 1);
                });
                e.preventDefault();
                e.stopPropagation();
                return false;
              });
              $(self.pn + ' table.data-input-table tbody tr:last-child').click(function (e) {
                self.editingID = $(this).attr("row-id");
                var code = $(this).find('.code').text();
                var qty = $(this).find('.qty').text();
                var note = $(this).find('.note').text();
                $(self.pn + ' input[name=dataline]').val("".concat(code, ";").concat(qty, ";").concat(note));
              });
              _context.next = 25;
              break;

            case 19:
              _tr = $(self.pn + ' table.data-input-table tbody tr[row-id="' + self.editingID + '"]');

              _tr.find('.code').text(code);

              _tr.find('.qty').text(qty);

              _tr.find('.note').text(note);

              self.editingID = 0;
              $(self.pn + ' input[name=dataline]').val('');

            case 25:
              self.saveDraft();

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function newline() {
      return _newline.apply(this, arguments);
    }

    return newline;
  }(),
  saveDraft: function saveDraft() {
    var self = this;
    var rowCount = $(self.pn + ' table.data-input-table tbody').find('tr').length;

    if (rowCount == 0) {
      // Utils.notiError('Dữ liệu trắng mà lưu nỗi gì chời...?');
      return false;
    }

    var currentTime = moment().format(Base.dateTimeFormat);

    if (self.draftKey == null) {
      self.draftKey = 'draft_' + currentTime;
      Base.draftKey = self.draftKey;
    }

    var data = [];
    $(self.pn + ' table.data-input-table tbody').find('tr').each(function (item, i) {
      var code = $(this).find('.code').text();
      var qty = $(this).find('.qty').text();
      var note = $(this).find('.note').text();
      data.push({
        code: code,
        qty: qty,
        note: note
      });
    });

    try {
      var dataJSON = JSON.stringify(data);
      localStorage.setItem(self.draftKey, dataJSON);
      Utils.notiInfo('Đã lưu lại bản nháp: ' + currentTime);
    } catch (e) {
      Utils.notiError('Không lưu được dữ liệu!');
      return false;
    }
  },
  newOrder: function newOrder() {
    var self = this;
    Base.app.dialog.confirm('Hãy chắc chắn rằng bạn đã lưu bản nháp (nếu cần) dữ liệu hiện thời sẽ bị xoá', 'Xác nhận', function () {
      $(self.pn + ' table.data-input-table tbody').html('');
      self.draftKey = null;
      Base.draftKey = null;
    });
  },
  sendOrder: function () {
    var _sendOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var self, rowCount, valid, codes, submitData, loading, rs, validRows, submitOrder, popupPreview;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              self = this;
              rowCount = $(self.pn + ' table.data-input-table tbody').find('tr').length;

              if (!(rowCount == 0)) {
                _context3.next = 5;
                break;
              }

              Utils.notiError('Dữ liệu trắng mà lưu nỗi gì chời...?');
              return _context3.abrupt("return", false);

            case 5:
              valid = true;
              codes = [];
              submitData = [];
              $(self.pn + ' table.data-input-table tbody').find('tr').each(function (item, i) {
                var code = $(this).find('.code').text();
                var qty = $(this).find('.qty').text();
                var note = $(this).find('.note').text();
                var isDuplicatedCode = false;

                for (var ii = 0; ii < codes.length; ii++) {
                  if (codes[ii] == code) {
                    Base.app.dialog.alert('Có lỗi ở dòng thứ ' + (i + 1) + '. Mã sản phẩm ' + code + ' đã tồn tại phía trên');
                    isDuplicatedCode = true;
                    break;
                  }
                }

                if (isDuplicatedCode) {
                  valid = false;
                  return valid;
                }

                codes.push(code);
                submitData.push({
                  code: code,
                  qty: qty,
                  note: note
                });
                valid = true;
              });

              if (!(valid == false || codes.length == 0)) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", false);

            case 11:
              loading = Base.app.dialog.preloader('Đang kiểm tra...');
              _context3.next = 14;
              return Base.api('Donhangdat', 'preview', {
                data: submitData
              });

            case 14:
              rs = _context3.sent;
              loading.close();

              if (!(rs.result != 'success')) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt("return", false);

            case 18:
              validRows = function validRows(items) {
                if (items.length == 0) return '<tr><td colspan="3" align="center">Không có dữ liệu hợp lệ</td></tr>';
                var rows = '';
                items.forEach(function (item, i) {
                  rows += "\n        <tr>\n          <td class=\"label-cell\">".concat(item.code, "</td>\n          <td class=\"label-cell\">").concat(item.name, "</td>\n          <td class=\"label-cell\">").concat(item.qty, "<div>").concat(item.note, "</div></td>\n        </tr>\n        ");
                });
                return rows;
              };

              submitOrder = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(items) {
                  var loading, rs;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          loading = Base.app.dialog.preloader('Đang gửi đơn...');
                          _context2.next = 3;
                          return Base.api('Donhangdat', 'submit', {
                            data: items
                          });

                        case 3:
                          rs = _context2.sent;
                          loading.close();
                          popupPreview.close();
                          Utils.notiInfo('Gửi đơn hàng thành công');

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function submitOrder(_x) {
                  return _ref.apply(this, arguments);
                };
              }();

              popupPreview = Base.app.popup.create({
                content: "\n        <div class=\"popup preview-popup\">\n          <div class=\"view\">\n            <div class=\"page\">\n              <div class=\"navbar\">\n                <div class=\"navbar-bg\"></div>\n                <div class=\"navbar-inner\">\n                  <div class=\"title\">X\xE1c nh\u1EADn \u0111\u01A1n \u0111\u1EB7t</div>\n                  <div class=\"right\">\n                    <a href=\"#\" class=\"link popup-close\"><i class=\"icon f7-icons\">multiply</i></a>\n                  </div>\n                </div>\n              </div>\n              <div class=\"toolbar tabbar toolbar-bottom\">\n                <div class=\"toolbar-inner\">\n                  <a href=\"#\" class=\"confirm-button button button-fill color-green\">X\xE1c Nh\u1EADn</a>\n                </div>\n              </div>\n              <div class=\"page-content\">\n                <div class=\"block-title invalid-code display-none\">M\xE3 h\xE0ng kh\xF4ng h\u1EE3p l\u1EC7</div>\n                <div class=\"block invalid-code display-none\">".concat(rs.errors.join(';'), "</div>\n                <div class=\"data-table\">\n                  <table>\n                    <thead>\n                      <tr>\n                        <th class=\"label-cell\">M\xE3</th>\n                        <th class=\"label-only\">T\xEAn h\xE0ng</th>\n                        <th class=\"label-cell\">SL</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      ").concat(validRows(rs.valids), "\n                    </tbody>\n                  </table>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      "),
                on: {
                  open: function open(popup) {
                    if (rs.errors.length > 0) $(popup.el).find('.invalid-code').removeClass('display-none');
                    if (rs.valids.length == 0) return false;
                    $(popup.el).find('.confirm-button').click(function () {
                      var submitItems = [];
                      rs.valids.forEach(function (item, i) {
                        submitItems.push({
                          id: item.id,
                          code: item.code,
                          qty: item.qty,
                          note: item.note
                        });
                      });
                      submitOrder(submitItems);
                    });
                  }
                }
              }).open();

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function sendOrder() {
      return _sendOrder.apply(this, arguments);
    }

    return sendOrder;
  }()
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Create.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  var saveDraft = function saveDraft() {
    Create.saveDraft();
  };

  var newOrder = function newOrder() {
    Create.newOrder();
  };

  var sendOrder = function sendOrder() {
    Create.sendOrder();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="create">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Tạo đơn nhặt hàng</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="fab fab-left-bottom color-orange">
      <a href="#">
        <i class="icon f7-icons">ellipsis_circle</i>
        <i class="icon f7-icons">ellipsis_vertical_circle</i>
      </a>
      <div class="fab-buttons fab-buttons-top">
        <a class="fab-label-button color-green" @click="${sendOrder}" href="#"><i class="icon f7-icons">paperplane</i><span class="fab-label">Gửi đơn</span></a>
        <a class="fab-label-button color-blue" @click="${newOrder}" href="#"><i class="icon f7-icons">doc</i><span class="fab-label">Tạo mới</span></a>
        <a class="fab-label-button color-teal" @click="${saveDraft}" href="#"><i class="icon f7-icons">square_pencil</i><span class="fab-label">Lưu nháp</span></a>
      </div>
    </div>
    <div class="page-content">
      <div class="list no-hairlines no-margin">
        <ul>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <form id="dataline"><input type="text" name="dataline" style="font-size:smaller;" placeholder="XXXX;1;Ghi chú (số lượng cho từng màu sắc, model,...)" /></form>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="data-table">
        <table class="data-input-table">
          <thead>
            <tr>
              <th width="1%">#</th>
              <th width="1%">Mã</th>
              <th>SL</th>
              <th width="1%"></th>
            </tr>
          </thead>
          <tbody>

          </tbody>
        </table>
      </div>
    </div>
  </div>
`
    }
    ;
});